<script>

    export let project;
    export let form;

    let result = "";
    let traceback = "";
    let files ;
    let loading =false;
    import {Button, Input,Card,CardBody,CardHeader} from 'sveltestrap';

    import {apiUrl} from '../../config.svelte';
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();

    
    function sendFileBinary(){
        loading=true;
        let fs =[...files];
        let farray = []
        result="";
        traceback="";
        fs.forEach(x=>{
            let fname = x.name;
            var reader = new FileReader();
            var fileByteArray = [];
            reader.readAsArrayBuffer(x);
            reader.onloadend = function (evt) {
                if (evt.target.readyState == FileReader.DONE) {
                    var arrayBuffer = evt.target.result,
                        array = new Uint8Array(arrayBuffer);
                    for (var i = 0; i < array.length; i++) {
                        fileByteArray.push(array[i]);
                    }
                }
                farray.push({filename:fname,data:fileByteArray})
                form.data=farray[0].data
                form.filename=farray[0].filename

                fetch(apiUrl+"uploads",{
                    credentials: "include",
                    method:"POST",
                    cors:'no-cors',
                    body:JSON.stringify({
                        method:"upload",
                        project:project,
                        form:form
                    })
                })
                .then(x=>x.json())
                .then(x=>{
                    loading =false;
                    if (x.result){
                        result = x.html
                    }else{
                        result = x.err
                        traceback = x.traceback
                    }
                })
                .catch((e)=>{
                    loading =false;
                    result = e;
                })
            }
        })
        


    }
</script>


<Card>
    <CardHeader>
        {form.title}
    </CardHeader>
    <CardBody>
        <Input type="file" bind:files />
        <Button style="float:right" outline color="dark" on:click={()=>{sendFileBinary()}}>Отправить{#if loading}<img src="/img/load-elem.gif" style="width:25px;height:25px" alt="loading" />{/if}</Button>
        <div >{result}</div>
        <div >{traceback}</div>
    </CardBody>

</Card>